import type { ReactNode } from 'react';
import { ModalsProvider } from '@mantine/modals';

export default function PacProvider({ children }: { children: ReactNode }) {
  return <ModalsProvider>{children}</ModalsProvider>;
}
